<template>
  <div class="form-step-6">
    <img
      class="form-step-6__logo"
      :src="logo"
    />
    <div class="form-step-6__title">
      <app-i18n
        tag="div"
        class="form-step-6__title__main"
        code="teamRegistrationSite.form.step6.title"
      />
      <app-i18n
        tag="div"
        class="form-step-6__title__sub"
        code="teamRegistrationSite.form.step6.subtitle"
      />
      <app-separator class="form-step-6__separator" />
    </div>
    <div class="form-step-6__content">
      <app-i18n
        tag="p"
        code="teamRegistrationSite.form.step6.text.first"
        :args="textArguments"
      />
      <app-i18n
        tag="p"
        code="teamRegistrationSite.form.step6.text.second"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import { i18n } from '@shared/i18n';

import AppSeparator from '@/components/Separator.vue'

import DoneIllustration from '@/assets/illustration-done.svg'

export default {
  name: 'appFormStep6',
  data() {
    return {
      i18n,
      logo: DoneIllustration,
    }
  },
  computed: {
    ...mapState('tournament', { tournamentName: 'name' }),
    ...mapGetters('teamRegistration', ['model']),
    textArguments() {
      return [
        this.model.clubContactPersons[0].firstName,
        this.model.clubName,
        this.tournamentName,
      ]
    },
  },
  components: {
    AppSeparator,
  },
}
</script>

<style lang="scss" scoped>
.form-step-6 {
  text-align: center;

  &__logo {
    --size: 240px;
    width: var(--size);
    height: var(--size);
  }

  &__title {
    font-size: 12px;
    font-weight: 300;
    line-height: 1.33;
    color: #333333;
    text-transform: uppercase;

    @include tablet {
      font-size: 16px;
    }

    &__main {
      font-size: 16px;
      margin: 16px 0;

      @include tablet {
        font-size: 20px;
      }
    }
  }

  &__separator {
    margin: 16px auto 24px;
    width: 80px;
  }

  &__content {
    font-size: 13px;
    color: #3a3a3a;

    @include tablet {
      font-size: 16px;
    }

    p {
      margin-bottom: 32px;
    }
  }

}
</style>
